import PostAuthor, { PostAuthorProps } from './PostAuthor'
import PostActions, { PostActionsProps } from './OpeningPostActions'
import PostMetadata, { PostMetadataProps } from './PostMetadata'
import PostContent, { OpeningPostContentProps } from './OpeningPostContent'
import OpeningPostContentActions, { OpeningPostContentActionsProps } from './OpeningPostContentActions'
import UserProfileActions from './UserProfileActions'
import PostAuthorSignature from './PostAuthorSignature'

export interface OpeningPostProps extends PostAuthorProps, PostMetadataProps, OpeningPostContentProps, PostActionsProps, OpeningPostContentActionsProps {}

const OpeningPost = ({ topicId, contentType, author, title, content, publishedAt, pending, spam, trashed, destinationUrl, pinnedReply, userId, votedBy, votes, likedBy, likes, showEditor, isProductboardNoteCreationEnabled, isSalesforceCaseEscalationEnabled, isZendeskTicketEscalationEnabled, isFreshdeskTicketEscalationEnabled, onShowEditor, onCancel, onChangeVote, onChangeLike, onShowAlert, onApprove, onChangeContent, publicId, visibleReplyCount }: OpeningPostProps) => {
  return (
    <div className='topic-moderation--posts-first'>
      <article data-post-id={topicId} className={`post panel panel-default status--author${spam ? ' status--spam' : ''}`}>
        <div className='post--inner-wrapper'>
          <div className='panel-body'>
            <PostAuthor author={author} />
            <div className='post--content-container'>
              <PostMetadata publishedAt={publishedAt} spam={spam} pending={pending} trashed={trashed} />
              <PostContent
                topicId={topicId}
                contentType={contentType}
                content={content}
                pinnedReply={pinnedReply}
                showEditor={showEditor}
                onChangeContent={onChangeContent}
                onCancel={onCancel}
                onShowAlert={onShowAlert}
              />
              {author.signature && <PostAuthorSignature signature={author.signature} />}
              {!spam && <OpeningPostContentActions
                author={author}
                content={content}
                topicId={topicId}
                contentType={contentType}
                trashed={trashed}
                votedBy={votedBy}
                likedBy={likedBy}
                votes={votes}
                likes={likes}
                userId={userId}
                isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
                isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
                isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
                isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
                onChangeVote={onChangeVote}
                onChangeLike={onChangeLike}
                        />}
            </div>
          </div>
          {!spam &&
            <div className='post__panel-footer clearfix'>
              <UserProfileActions authorId={author.id} loggedInUserId={userId} />
              <PostActions
                topicId={topicId}
                contentType={contentType}
                author={author}
                title={title}
                content={content}
                pending={pending}
                trashed={trashed}
                userId={userId}
                destinationUrl={destinationUrl}
                isProductboardNoteCreationEnabled={isProductboardNoteCreationEnabled}
                isSalesforceCaseEscalationEnabled={isSalesforceCaseEscalationEnabled}
                isZendeskTicketEscalationEnabled={isZendeskTicketEscalationEnabled}
                isFreshdeskTicketEscalationEnabled={isFreshdeskTicketEscalationEnabled}
                onApprove={onApprove}
                onShowAlert={onShowAlert}
                onShowEditor={onShowEditor}
                publicId={publicId}
                visibleReplyCount={visibleReplyCount}
              />
            </div>}
        </div>
      </article>
    </div>
  )
}

export default OpeningPost
